// Profile definitions (style, cognitive_config etc.) bundled by scripts/sync-profiles.mjs.
const definitions = import.meta.glob<Record<string, unknown>>('./profiles/*.json', { eager: true, import: 'default' });

export function profileDefinition(id: string): Record<string, unknown> {
  const def = definitions[`./profiles/${id}.json`];
  if (!def) throw new Error(`Profile definition for "${id}" is not bundled — run \`npm run sync\`.`);
  return def;
}
